import { queryOptions, skipToken } from '@tanstack/react-query'

import { getMenuProductRatingAverages } from '../service/combinedapi/menuProductRatingAverages'
import { getMenuProductRatingAveragesFromCDN } from '../service/cdn/menuProductRatingAverages'
import { isRatingsCDNEnabled } from '../service/cdn/ratingsCDN'

async function getMenuProductRatingAveragesPreferringCDN({
  menuID,
}: {
  menuID: string
}) {
  if (!isRatingsCDNEnabled()) {
    return getMenuProductRatingAverages({ menuID })
  }

  try {
    return await getMenuProductRatingAveragesFromCDN({ menuID })
  } catch {
    return getMenuProductRatingAverages({ menuID })
  }
}

export const menuProductRatingAverageQueries = {
  list: ({ menuID }: { menuID: string | undefined }) =>
    queryOptions({
      queryKey: ['menuProductRatingAverages', menuID],
      queryFn: menuID
        ? () => getMenuProductRatingAveragesPreferringCDN({ menuID })
        : skipToken,
    }),
}
